/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/offer';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveOfferRequest": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveOfferResponse": {
                "fields": {
                  "offer": {
                    "type": ".squareup.corporate_card.resources.Offer",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveOfferRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveOfferResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveOfferRequest @ squareup/corporate_card/service/retrieve_offer.proto at 10:1
 */
export const RetrieveOfferRequest = $root.lookupType('squareup.corporate_card.service.RetrieveOfferRequest');
fixType(RetrieveOfferRequest, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveOfferRequest);
/**
 * SOURCE RetrieveOfferResponse @ squareup/corporate_card/service/retrieve_offer.proto at 21:1
 */
export const RetrieveOfferResponse = $root.lookupType('squareup.corporate_card.service.RetrieveOfferResponse');
fixType(RetrieveOfferResponse);
Builder.createAndAttachToType(RetrieveOfferResponse);